<template>
    <div class="code-snippet grid grid__base">
        <div class="grid--container" v-if="title">
            <h2 class="code-snippet--title">{{ title }}</h2>
        </div>
        <div class="code-snippet--code" ref="code"/>
    </div>
</template>

<script>
    /* eslint-disable no-eval */
    /**
     * This code is one of the ugliest and most dangerous patch I have ever done in my career.
     * I had to implement it due to a specific client / dreipol CEO request https://app.asana.com/0/137886543980536/1202660004813333
     * I am not responsible for any issue or damage caused to the application due to this "feature request"
     */
    import decode from 'unescape';
    import { memoize } from 'lodash';

    const unescape = (str) => {
        return decode(str).replace(/&#x([0-9a-f]+);/gi, (_, code) =>
            String.fromCharCode(parseInt(code, 16))
        );
    };

    // make sure that scripts with the same src do not get injected twice
    const injectScript = memoize((src) => {
        const script = document.createElement('script');
        script.src = src;
        document.head.appendChild(script);
    });

    export default {
        props: {
            title: {
                type: String,
                default() {
                    return '';
                },
            },
            code: {
                type: String,
                required: true,
            },
        },
        methods: {
            evalScripts() {
                Array.from(this.$el.querySelectorAll('script')).forEach(script => {
                    const src = script.getAttribute('src');
                    if (src) {
                        injectScript(src);
                    } else if (script.innerHTML) {
                        eval(script.innerHTML);
                    }

                    // remove the inline script
                    script.parentNode.removeChild(script);
                });
            },
        },
        mounted() {
            const unescapedCode = unescape(this.code);

            this.$refs.code.innerHTML = unescapedCode;

            this.evalScripts();
        },
    };
</script>
